<template>
  <div v-if="visible" class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-content">
      <div class="modal-header">
        <h2>選項管理</h2>
        <button @click="$emit('close')" class="close-button">&times;</button>
      </div>
      <div class="modal-body">
        <div class="tables-container">
          <div class="table-section">
            <h3>顏色列表</h3>
            <table class="options-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>名稱</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="color in colors" :key="color.id">
                  <td>{{ color.id }}</td>
                  <td>{{ color.name }}</td>
                  <td>
                    <button @click="deleteColor(color.id)" class="delete-item-btn" :disabled="userAuthority > 1">刪除</button>
                  </td>
                </tr>
                <tr v-if="userAuthority <= 1">
                  <td></td>
                  <td><input type="text" v-model="newColorName" placeholder="新顏色名稱" class="new-item-input"></td>
                  <td><button @click="addColor" class="add-item-btn">新增</button></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="table-section">
            <h3>顧客來源列表</h3>
            <table class="options-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>名稱</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="source in customerSources" :key="source.id">
                  <td>{{ source.id }}</td>
                  <td>{{ source.name }}</td>
                  <td>
                    <button @click="deleteCustomerSource(source.id)" class="delete-item-btn" :disabled="userAuthority > 1">刪除</button>
                  </td>
                </tr>
                <tr v-if="userAuthority <= 1">
                  <td></td>
                  <td><input type="text" v-model="newCustomerSourceName" placeholder="新顧客來源名稱" class="new-item-input"></td>
                  <td><button @click="addCustomerSource" class="add-item-btn">新增</button></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OptionsManage',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    userAuthority: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      colors: [],
      customerSources: [],
      newColorName: '',
      newCustomerSourceName: ''
    };
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        this.fetchColors();
        this.fetchCustomerSources();
      }
    }
  },
  methods: {
    async fetchColors() {
      try {
        const response = await fetch('/api/colors');
        if (!response.ok) throw new Error('Failed to fetch colors');
        this.colors = await response.json();
      } catch (error) {
        console.error('Error fetching colors:', error);
        alert('載入顏色列表失敗');
      }
    },
    async addColor() {
      if (!this.newColorName.trim()) return;
      try {
        const response = await fetch('/api/colors', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: this.newColorName })
        });
        if (!response.ok) throw new Error('Failed to add color');
        const newColor = await response.json();
        this.colors.push(newColor);
        this.newColorName = '';
      } catch (error) {
        console.error('Error adding color:', error);
        alert('新增顏色失敗');
      }
    },
    async deleteColor(id) {
      if (!confirm('確定要刪除此顏色嗎？')) return;
      try {
        const response = await fetch(`/api/colors/${id}`, { method: 'DELETE' });
        if (!response.ok) throw new Error('Failed to delete color');
        this.colors = this.colors.filter(color => color.id !== id);
      } catch (error) {
        console.error('Error deleting color:', error);
        alert('刪除顏色失敗');
      }
    },
    async fetchCustomerSources() {
      try {
        const response = await fetch('/api/customer_sources');
        if (!response.ok) throw new Error('Failed to fetch customer sources');
        this.customerSources = await response.json();
      } catch (error) {
        console.error('Error fetching customer sources:', error);
        alert('載入顧客來源列表失敗');
      }
    },
    async addCustomerSource() {
      if (!this.newCustomerSourceName.trim()) return;
      try {
        const response = await fetch('/api/customer_sources', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ name: this.newCustomerSourceName })
        });
        if (!response.ok) throw new Error('Failed to add customer source');
        const newSource = await response.json();
        this.customerSources.push(newSource);
        this.newCustomerSourceName = '';
      } catch (error) {
        console.error('Error adding customer source:', error);
        alert('新增顧客來源失敗');
      }
    },
    async deleteCustomerSource(id) {
      if (!confirm('確定要刪除此顧客來源嗎？')) return;
      try {
        const response = await fetch(`/api/customer_sources/${id}`, { method: 'DELETE' });
        if (!response.ok) throw new Error('Failed to delete customer source');
        this.customerSources = this.customerSources.filter(source => source.id !== id);
      } catch (error) {
        console.error('Error deleting customer source:', error);
        alert('刪除顧客來源失敗');
      }
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  width: 90%;
  max-width: 1000px; /* Adjust max-width as needed */
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  margin-bottom: 20px;
}

.modal-header h2 {
  margin: 0;
  color: #2c3e50;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
}

.close-button:hover {
  color: #333;
}

.modal-body {
  flex-grow: 1;
  overflow-y: auto;
  padding-right: 10px; /* For scrollbar */
}

.tables-container {
  display: flex;
  gap: 20px; /* Space between tables */
  justify-content: space-around;
  flex-wrap: wrap; /* Allow tables to wrap on smaller screens */
}

.table-section {
  flex: 1; /* Allow sections to grow and shrink */
  min-width: 300px; /* Minimum width for each table section */
  background: #f8f9fa;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.table-section h3 {
  color: #2c3e50;
  margin-top: 0;
  margin-bottom: 15px;
  font-size: 1.1em;
  text-align: center;
}

.options-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
}

.options-table th,
.options-table td {
  padding: 10px;
  border: 1px solid #ddd;
  text-align: left;
}

.options-table th {
  background-color: #e9ecef;
  font-weight: 600;
  color: #495057;
}

.options-table tbody tr:nth-child(even) {
  background-color: #f6f6f6;
}

.options-table tbody tr:hover {
  background-color: #f0f0f0;
}

.new-item-input {
  width: calc(100% - 10px);
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.add-item-btn, .delete-item-btn {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9em;
  transition: background-color 0.3s;
}

.add-item-btn {
  background-color: #28a745;
  color: white;
}

.add-item-btn:hover {
  background-color: #218838;
}

.delete-item-btn {
  background-color: #dc3545;
  color: white;
}

.delete-item-btn:hover {
  background-color: #c82333;
}
</style>
